<button class="actionbtn" type="button" (click)="onClick($event)">{{label}}</button>
